import { Text } from '@wework/dieter-ui'
import React, { useState } from 'react'

export default function Linkeable({ space }) {
  const [showDetails, setShowDetails] = useState(false)
  return (
    <div style={{ flex: 1 }}>
      <div style={styles.container}>
        <div style={{ marginBottom: 16 }}>
          <Text color="grey" size="small">
            Space Name
          </Text>
          <Text>{space.number}</Text>
        </div>
        {!showDetails ? (
          <Text primary size="small" onClick={() => setShowDetails(true)}>
            Details
          </Text>
        ) : (
          <>
            <div>
              <Text color="grey" size="small">
                Physical UUID
              </Text>
              <Text>{space.uuid}</Text>
            </div>
            <Text primary size="small" onClick={() => setShowDetails(false)}>
              Hide Details
            </Text>
          </>
        )}
      </div>
    </div>
  )
}

const styles = {
  container: {
    border: '1px solid #E6E6E6',
    borderRadius: 8,
    padding: 16,
  },
}
